<template>
  <div v-if="ready" class="feature">
    <FeatureMeta :feature="featureStore.feature" />

    <div v-if="featureStore.images.length === 0">
      <FeatureInitSection include-uploader :feature="featureStore.feature" :intro-count="2" :sample-count="4" />
      <PageColorizeBlackAndWhite />
    </div>

    <div v-else class="h-full">
      <LayoutDefault show-cost :total-cost="totalCost" @finished="onFinished"> </LayoutDefault>
    </div>
  </div>

  <div v-else class="feature-loader">
    <img src="@/images/system/loader.gif" alt="Loader" />
  </div>
</template>

<script setup lang="ts">
  import { useFeatureSetup } from '$/composables/useFeatureSetup'
  import { useCostCalculate } from '$/composables/useCostCalculate'
  import PageColorizeBlackAndWhite from '&/landing_pages/PageColorizeBlackAndWhite.vue'
  import FeatureMeta from '&/FeatureMeta.vue'

  const { ready, router, featureStore, LayoutDefault, FeatureInitSection, watchTaskOptions } = useFeatureSetup()

  watchTaskOptions()

  function onFinished() {
    router.push({ name: 'ColorizeBlackAndWhiteResult' })
  }
  const { totalCost } = useCostCalculate()
</script>
